import themeService from '../../themes/themeService';
const { palette } = themeService.getTheme();
const tableStyles = {
    root: {
        cursor: 'pointer',
        '&:hover': {
            background: palette.table.hover
        },
        '&:focus': {
            background:  palette.table.hover,
            boxShadow: `0 0 1.5rem ${palette.primary.main}`
        },
        fontSize: '0.8125rem',
        fontWeight: '400'
    }
};
export default tableStyles;